import { useEffect, useState } from "react";
import { useParams } from "react-router";
import "./portfolioStyling.css";
import { DataInterface, PORTFOLIO_ADDED_ALBUMS } from "../Portfolio/Portfolio";
import { PhotoModal } from "../../organisms/Modal/components/PhotoModal";

export interface ModalProps {
  modal: string;
  data: string;
}

export const PortfolioGalary = () => {
  const [modal, setModal] = useState({ modal: "", data: "" });

  const { portfolioId } = useParams();
  const [data, setDate] = useState<DataInterface>();

  const onImgClick = (index: number) => {
    setModal({
      modal: "photoModal",
      data: `${data?.folderURL}/${index + 1}-full.${data?.imgFormatFull || data?.imgFormat}`
    });
  };

  useEffect(() => {
    if (!portfolioId) {
      return;
    }
    const portfolioObjectKey =
      portfolioId as keyof typeof PORTFOLIO_ADDED_ALBUMS;
    setDate(PORTFOLIO_ADDED_ALBUMS[portfolioObjectKey]);
  }, [portfolioId]);

  return (
    <>
      <div className="bg-black pb-20 pt-5 text-white">
        <div className="mx-auto flex max-w-7xl flex-wrap">
          {data &&
            [...Array(data?.index)].map((a, index) => (
              <div key={index} className="mb-10 flex w-1/2 flex-col lg:w-1/3">
                <div
                  className={`ml-2 flex max-w-96 flex-col hover:opacity-80`}
                  onClick={() => onImgClick(index)}
                >
                  <img
                    src={`${data?.folderURL}/${index + 1}.${data?.imgFormat}`}
                    alt={`gallery ${data?.name} ${index + 1} photo`}
                    className="rounded border-2 border-cream-700 p-0.5"
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
      {modal.modal === "photoModal" && (
        <PhotoModal modal={modal} setModal={setModal} />
      )}
    </>
  );
};
